var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'prezzo' : !!this.graphicLayout, 'prezzo-nofoto': !this.graphicLayout}},[_vm._v("\n    "+_vm._s(this.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }